<div class="flex-row column align-center row-gap-20 d-none-md">
    <div class="flex-row position-relative">
        <img src={{data.baseUrl}}{{webPopup.file}} alt="Popup file">
        <button type="button"
            class="flex-row full tw-bg-transparent tw-border-0 tw-p-0 content-end tw-right-0 cursor-pointer position-absolute"
            (click)="closeDialog()">
            <img src="assets/new-assets/icons/popup-close.svg" alt="Close">
        </button>
    </div>
    <div class="flex-row column p-20 row-gap-15">
        <h3 class="fs-24 text-center">{{data.title}}</h3>
        <p class="text-center">{{data.message}}</p>
    </div>
</div>
<div class="flex-row column align-center row-gap-20 d-none d-flex-md">
    <div class="flex-row position-relative">
        <img src={{data.baseUrl}}{{mobilePopup.file}} alt="Popup file">
        <button type="button"
            class="flex-row full tw-bg-transparent tw-border-0 tw-p-0 tw-right-0 content-end cursor-pointer position-absolute"
            (click)="closeDialog()">
            <img src="assets/new-assets/icons/popup-close.svg" alt="Close">
        </button>
    </div>
    <div class="flex-row column p-20 row-gap-15">
        <h3 class="fs-24 text-center">{{data.title}}</h3>
        <p class="text-center">{{data.message}}</p>
    </div>
</div>